import { forwardRef, type InputHTMLAttributes, type LabelHTMLAttributes, type SelectHTMLAttributes, type TextareaHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export function FieldLabel({ className, children, ...props }: LabelHTMLAttributes<HTMLLabelElement> & { required?: boolean }) {
  const required = props.required;
  const labelProps = { ...props };
  delete labelProps.required;
  return <label className={cn("mb-1.5 block text-xs font-bold uppercase tracking-wide text-ink-muted", className)} {...labelProps}>{children}{required ? <span className="ml-1 text-danger-600">*</span> : null}</label>;
}

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input({ className, ...props }, ref) {
  return <input ref={ref} className={cn("min-h-11 w-full rounded-xl border border-border bg-white px-3.5 text-sm text-ink shadow-sm placeholder:text-ink-muted/65 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-100 disabled:bg-surface-muted", className)} {...props} />;
});

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(function Select({ className, ...props }, ref) {
  return <select ref={ref} className={cn("min-h-11 w-full rounded-xl border border-border bg-white px-3.5 text-sm text-ink shadow-sm focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-100 disabled:bg-surface-muted", className)} {...props} />;
});

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea({ className, ...props }, ref) {
  return <textarea ref={ref} className={cn("min-h-28 w-full resize-y rounded-xl border border-border bg-white px-3.5 py-3 text-sm text-ink shadow-sm placeholder:text-ink-muted/65 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-100 disabled:bg-surface-muted", className)} {...props} />;
});

export function FieldError({ message }: { message?: string }) {
  return message ? <p className="mt-1.5 text-xs font-medium text-danger-600">{message}</p> : null;
}

export function HelpText({ children }: { children: ReactNode }) {
  return <p className="mt-1.5 text-xs leading-5 text-ink-muted">{children}</p>;
}
